import axios from 'axios';

export default class AxiosManager {
    api() {
        return axios;
    }
}